"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.packageFamilySearchSchema = void 0;
const zod_1 = require("zod");
exports.packageFamilySearchSchema = zod_1.z.object({ name: zod_1.z.string() });
//# sourceMappingURL=search.dto.js.map